import { RouteComponentProps } from '@reach/router';
import { ComponentClass, FunctionComponent } from 'react';

export interface ComponentRoute {
    /** Any child routes that appear under this one **/
    children?: RouteSpec;

    /** Component to render at this spot in the hierarchy **/
    component: ComponentClass<RouteComponentProps, any> | FunctionComponent<RouteComponentProps>;

    /** Name of the path to show in the breadcrumbs **/
    label?: string;
}

export interface RedirectRoute {
    redirectTo: string;
}

export interface RouteSpec {
    [pattern: string]: ComponentRoute | RedirectRoute;
}

export const DEFAULT = 'DEFAULT';
